export const createEmptyAndDuplicateLists = (columns: string[][], qrCodeIndex: number) => {
  const emptyRows: number[] = [];
  const duplicateRows: number[] = [];
  const qrCodeValues = new Set<string>();

  if (qrCodeIndex !== -1) {
    columns[qrCodeIndex].forEach((value, rowIndex) => {
      if (!value.trim()) {
        emptyRows.push(rowIndex + 1);
      } else if (qrCodeValues.has(value)) {
        duplicateRows.push(rowIndex + 1);
      } else {
        qrCodeValues.add(value);
      }
    });
  }
  return {
    emptyRows,
    duplicateRows,
  };
};
